<template>
  <div class="app_cp">
    <div class="homebanner">
      <img src="@/assets/home/b1.png" alt="">
    </div>
    <div class="homerecommend">
      <div class="pl" style="margin-right: -100px;padding-left: 45px;">
        <div class="homerecommendTxtmg" v-for="(item, index) in str1.list" :key="index" @click="shopDetails(item.id)">
          <div class="boximg">
            <img :src="item.img" alt="">
          </div>
          <div class="text">
            <h5>{{ item.title }}</h5>
            <p>
              <span class="chang">厂</span>
              <span class="Pspan">{{ item.manufactor }}</span>
            </p>
          </div>
        </div>
      </div>

    </div>

    <div class="demo-pagination-block">
      <el-pagination v-model:current-page="currentPage4" v-model:page-size="pageSize4" :page-sizes="[10, 20, 30, 40]"
        :small="small" :disabled="disabled" :background="background" layout="total, sizes, prev, pager, next, jumper"
        :total="1" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue"
import { useRouter, useRoute } from 'vue-router'

let str1 = reactive({
  list: [
    {
      id: "xg",
      title: "桂林西瓜霜",
      manufactor: "桂林三金药业股份有限公司",
      img: require("@/assets/home/a2.png")
    },
    {
      id: "cy",
      title: "肠炎宁片",
      manufactor: "江西康恩贝中药有限公司",
      img: require("@/assets/home/a5.png")
    },
    {
      id: "gm",
      title: "感冒灵颗粒",
      manufactor: "华润三九医药股份有限公司",
      img: require("@/assets/home/gm/home.jpg")
    },
    {
      id: "rs",
      title: "乳酸菌素片",
      manufactor: "江中药业股份有限公司",
      img: require("@/assets/home/rs/home.jpg")
    }
  ]
})

const router = useRouter()
function shopDetails (id) {
  router.push({
    path: `details`,
    query: { id }
  })
}
function handleSizeChange (val) {
  console.log(val, "条");
}
function handleCurrentChange (val) {
  console.log(val, "页");
}
</script>

<style scoped lang="less">
.app_cp {
  background: #ffffff;
  padding-bottom: 20px;
}

.homebanner {
  img {
    width: 100%;
  }
}

.homerecommendTxtmg:hover {
  cursor: pointer;
}

.homerecommend {
  width: 999px;
  margin: 0 auto;
  margin-top: -5px;
  padding: 28px 0px;

  .homerecommendtop {
    text-align: center;
    margin-bottom: 25px;
    display: flex;
    justify-content: center;

    .colorhover1 {
      margin-right: 50px;
    }

    // .colorhover1:hover {
    //   color: red;
    // }
    // .colorhover2:hover {
    //   color: red;
    // }
    .heng {
      display: block;
      width: 38px;
      height: 3px;
      background-color: #116d52;
      margin: 3px auto;
    }
  }

  .homerecommendtop:hover {
    cursor: pointer;
  }

  .homerecommendTxtmg {
    width: 156px;
    margin-right: 93px;

    display: inline-block;
    text-align: center;
    margin-top: 20px;

    .boximg {
      width: 119px;
      height: 109px;
      padding: 20px;
      border: 1px solid #d9d9d9;
    }

    img {
      width: 72px;
      height: 87px;
      transition: all 0.3s ease;
    }

    img:hover {
      transform: scale(1.1);
    }

    .text {
      text-align: left;

      h5 {
        margin: 7px 0px;
        width: 156px;
        height: 35px;
        font-size: 12px;
        -webkit-line-clamp: 2;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      p {
        margin: 0px;
        font-size: 12px;
        display: flex;

        .chang {
          width: 18px;
          height: 15px;
          text-align: center;
          background-color: #b4c8ff;
          margin-right: 5px;
        }

        .Pspan {
          width: 156px;

          -webkit-line-clamp: 1;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}

.demo-pagination-block {
  display: flex;
  justify-content: center;
}
</style>
